import * as React from 'react'
import { useState } from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FactorialTip from 'modules/core/components/FactorialTip'
import i18n from 'modules/core/lib/i18n'

import type PolicyForm from 'modules/timeoff/lib/BlockedPeriods/PolicyUpdateForm'
import type { ITimePeriod as PeriodAttributes } from 'modules/timeoff/lib/BlockedPeriods/TimePeriod'
import TimePeriodForm from 'modules/timeoff/lib/BlockedPeriods/TimePeriodForm'

import FormModal from './FormModal'
import PeriodList from './PeriodList'

interface WarningBoxProps {
  title: string
  description: string
}

interface Props {
  policyForm: PolicyForm
  onDelete: () => void
}

const WarningBox = ({ title, description }: WarningBoxProps) => (
  <FactorialTip
    background="champagne100"
    iconColor="champagne1000"
    title={title}
    icon="alert"
    message={description}
  />
)

const TimePeriods = ({ policyForm, onDelete }: Props) => {
  const [newTimePeriodForm, setTimePeriodForm] = useState<TimePeriodForm | null | undefined>(null)

  const openModal = () => setTimePeriodForm(new TimePeriodForm())
  const closeModal = () => {
    setTimePeriodForm(null)
  }

  const onSave = (payload: PeriodAttributes) => {
    const timePeriods = policyForm.get('time_periods').value
    const periods = [payload, ...timePeriods]

    policyForm.setValues({
      time_periods: periods,
    })
    closeModal()
  }

  return (
    <Section
      illustration="network"
      title={i18n.t('settings.timeoff_blocked_periods.detail.time_periods.title')}
      description={i18n.t('settings.timeoff_blocked_periods.detail.time_periods.description')}
      action={{
        label: i18n.t('settings.timeoff_blocked_periods.detail.time_periods.add_button'),
        onClick: openModal,
      }}
    >
      <Box gap="s16">
        {policyForm.hasMultipleContractPeriods && (
          <WarningBox
            title={i18n.t('settings.timeoff_blocked_periods.detail.time_periods.warning.title')}
            description={i18n.t(
              'settings.timeoff_blocked_periods.detail.time_periods.warning.description'
            )}
          />
        )}

        {!policyForm.timePeriods.length && (
          <WarningBox
            title={i18n.t(
              'settings.timeoff_blocked_periods.detail.time_periods.warning_empty.title'
            )}
            description={i18n.t(
              'settings.timeoff_blocked_periods.detail.time_periods.warning_empty.description'
            )}
          />
        )}

        {!!policyForm.timePeriods.length && (
          <PeriodList policyForm={policyForm} onDeletePeriod={onDelete} />
        )}
      </Box>

      {!!newTimePeriodForm && (
        <FormModal
          timePeriodForm={newTimePeriodForm}
          closeModal={closeModal}
          onSave={onSave}
          isNew
        />
      )}
    </Section>
  )
}

export default observer(TimePeriods)
